(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('MapasInfestacaoService', MapasInfestacaoService);

  MapasInfestacaoService.$inject = [
    '$http'
  ];

  function MapasInfestacaoService($http) {
    const service = {
      generate
    };
    return service;

    function generate(filters = {}) {
      filters = {
        start_date: filters.startDate,
        end_date: filters.endDate
      };

      return $http.post(`${SERVER }v1/ocorrencias/mapa_infestacao`, filters);
    }
  }
}());
